<script>
import { mapGetters } from 'vuex'
import ChargeResource from '@/resources/charge'
import TermsOfServiceLink from '../../components/TermsOfServiceLink.vue'

export default {
    name: 'AccountSubscription',
    components: { TermsOfServiceLink },
    computed: {
        ...mapGetters(['userResource', 'isApexClub', 'creditsBalance'])
    },
    methods: {
        async onUnenrollSubscription() {
            this.$refs.cancelSubscription.hide()
            await ChargeResource.creditUnenrollUser()
            this.userResource.set('credits_subscription_in_good_standing', false)
        },
        nthDayOfMonth(day) {
            const moment = require('moment')
            return moment(day, 'D').format('Do')
        }
    }
}
</script>

<template>
    <div>
        <div class="mb-4">
            <h4 class="mb-1">Abonnement</h4>
            <p class="text-muted mb-0">Verwalten Sie Ihre {{ $appConfig('APEX_CLUB_NAME', 'Apex Club') }} Mitgliedschaft.</p>
        </div>

        <b-card v-if="userResource.attributes.credits_subscription_in_good_standing">
            <dl class="row mb-0">
                <dt class="col-sm-4">Apex Club</dt>
                <dd class="col-sm-8"><strong class="text-success"><b-icon icon="patch-check-fill" /> Mitglied</strong></dd>
                <dt class="col-sm-4">Guthabenstand</dt>
                <dd class="col-sm-8"><strong><b-icon icon="currency-exchange" /> {{ creditsBalance }} Guthaben</strong></dd>
                <dt class="col-sm-4">Abonnement</dt>
                <dd class="col-sm-8">
                    <strong><b-icon icon="arrow-repeat" /> {{ userResource.attributes.credits_recurring }} Guthaben monatlich am {{ nthDayOfMonth(userResource.attributes.credits_cycle_day_of_month) }} — {{ currencySymbol() }}{{ moneyFormat(userResource.attributes.credits_recurring_cents) }}</strong>
                </dd>
            </dl>
            <template #footer>
                <small><a href="javascript:{};" class="text-muted" @click="$refs.cancelSubscription.show()">Abonnement kündigen</a></small>
            </template>
        </b-card>

        <b-alert variant="danger" show v-else-if="!userResource.attributes.credits_subscription_in_good_standing && userResource.attributes.credits_subscription_exists">
            <strong>Oh-oh!</strong> Ihre {{ $appConfig('APEX_CLUB_NAME', 'Apex Club') }} Mitgliedschaft ist nicht in gutem Zustand. Bitte
            <router-link :to="{ name: 'accountPayment' }">überprüfen Sie Ihre Zahlungsmethode</router-link>, um dies zu beheben.
        </b-alert>

        <b-alert variant="info" show v-else>
            <strong>Sparen Sie 20% bei jedem Rennen</strong> durch den Beitritt zum <strong>{{ $appConfig('APEX_CLUB_NAME', 'Apex Club') }}</strong>. (Und noch viel mehr!)
            <router-link :to="{ name: 'subscription' }">Mehr Infos</router-link>
        </b-alert>

        <b-modal
            title="Abonnement kündigen"
            ref="cancelSubscription"
            @ok="onUnenrollSubscription()"
            :ok-disabled="!userResource.attributes.credits_subscription_cancelable"
            cancel-title="Nicht kündigen"
            cancel-variant="primary"
            ok-title="Abonnement kündigen"
            ok-variant="danger"
            centered
            no-fade>
            <p>Sind Sie sicher, dass Sie Ihr Abonnement kündigen möchten? Diese Aktion ist unwiderruflich.
                <span v-if="creditsBalance > 0"> <strong>Sie verlieren Ihr Guthaben von {{ creditsBalance }} Credits!</strong> Erwägen Sie, Ihr Guthaben zu verwenden, bevor Sie kündigen.</span>
            </p>
            <b-alert variant="danger" :show="!userResource.attributes.credits_subscription_cancelable">
                <strong>Entschuldigung, Sie können noch nicht kündigen</strong> — Sie müssen mindestens zwei Abrechnungszyklen Mitglied sein. Bitte überprüfen Sie unsere <terms-of-service-link text="Nutzungsbedingungen" el="span" />.
            </b-alert>
        </b-modal>
    </div>
</template>
